<div class="home-header">
  <app-secondary-logo class="home-header__secondary-logo-icon" />
  <div class="home-header__wrapper">
    <button
      type="button"
      class="home-header__feedback"
      (click)="openFeedbackModal()"
      aria-label="Open feedback modal"
    >
      <app-icon class="icon" [icon]="IconName.FEEDBACK" />
    </button>
    <div class="home-header__notify">
      <app-icon class="icon" [icon]="IconName.NOTIFY" />
    </div>
    <div class="home-header__data" [matMenuTriggerFor]="userActions">
      <div class="home-header__picture-wrapper">
        <img
          class="home-header__avatar"
          [src]="userPhotoSignal()"
          alt="user-avatar"
          (error)="onImageError()"
          [class.hidden]="!userPhotoSignal()"
        />
        @if (!userPhotoSignal()) {
          <div class="home-header__initials">
            {{ getInitials() }}
          </div>
        }
      </div>
      <div class="home-header__info">
        <div class="home-header__name">
          {{ userDataSignal()?.data?.firstName }} {{ userDataSignal()?.data?.lastName }}
        </div>
        <div class="home-header__status">User</div>
      </div>
    </div>
  </div>
</div>

<mat-menu class="menu-header" [class]="'menu-header'" #userActions="matMenu">
  <button class="menu-header__menu-item" [routerLink]="appRoutes.PROFILE" mat-menu-item>
    <app-icon class="icon" [icon]="IconName.PROFILE" />
    <span>{{ 'homeHeader.profile' | translate }}</span>
  </button>
  <button class="menu-header__menu-item" (click)="logout()" mat-menu-item>
    <app-icon class="icon" [icon]="IconName.LOGOUT" />
    <span>{{ 'homeHeader.logout' | translate }}</span>
  </button>
</mat-menu>
